<template>

    <div class="site__container pt-64">
        <div v-if="shouldRender" class="-mx-8 mb-64">
            <div
                class="px-8 mx-auto text-center scroll-scene__header"
                :class="[ hasAnimationClasses ? 'opacity-0' : '', containerWidth ]"
            >
                <h1
                    v-if="hasTitle"
                    class="font-semibold whitespace-pre-line site__font--display"
                    :class="[ hasDescription ? 'mb-24' : '', titleSize ]"
                v-html="title.trim()"></h1>
              <section
                    v-if="hasDescription"
                    :data-version="version"
                    :class="textSize"
                    class="flex-grow wysiwyg-content min-w-0"
                    v-html="description"
                >
              </section>
            </div>
        </div>
    </div>

</template>

<script>
import { runningInBrowser, responsive } from '../../helpers';
import { mapState } from 'pinia';
import { useBrandingStore } from '../../state/branding'

export default {
    props: {
        title: String,
        description: String,
    },
    computed: {
        ...mapState(useBrandingStore, ['preview']),
        version() {
            return runningInBrowser() ? 'preview-' + this.preview.type : 'live';
        },
        hasTitle () {
            return !this.title ? false : this.title.length !== 0;
        },
        hasDescription () {
            return !this.description ? false : this.description.length !== 0;
        },
        shouldRender () {
            return this.hasTitle || this.hasDescription;
        },
        hasAnimationClasses () {
            return !runningInBrowser();
        },
        containerWidth () {
            return responsive(this.preview.type, 'w-full md:w-2/3');
        },
        titleSize () {
            return responsive(this.preview.type, 'text-heading-1 lg:text-big');
        },
        textSize() {
            return responsive(this.preview.type, 'text-body md:text-heading-2');
        },
        descriptionSize () {
            return responsive(this.preview.type, 'text-body md:text-heading-2');
        }
    }
}
</script>
